export enum ConsultantStatus {
  NotStarted = 0,
  Active = 1,
  EndingSoon = 2,
  Ended = 3,
}
